"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6588],{

/***/ 76588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ ImageTextFlexBox; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74129);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95197);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57833);
/* harmony import */ var qualification_hooks_useBreakpoints__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19916);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  text-align: start;\n  gap: ",
        "px;\n\n  ",
        " {\n    gap: ",
        "px;\n    flex-direction: row;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







function ImageTextFlexBox(param) {
    var alt = param.alt, caption = param.caption, image = param.image, imageAlign = param.imageAlign, title = param.title, backgroundColor = param.backgroundColor;
    var ref, ref1, ref2;
    var backgroundImage = (image === null || image === void 0 ? void 0 : (ref = image.fields) === null || ref === void 0 ? void 0 : ref.file) ? "https:".concat((ref1 = image.fields) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.file) === null || ref2 === void 0 ? void 0 : ref2.url, "?w=600") : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_4__.Box, {
        style: {
            background: backgroundColor || "#FFF"
        },
        my: 3,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_4__.Box, {
            maxWidth: 1050,
            mx: "auto",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Advantage, {
                children: [
                    backgroundImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_4__.Box, {
                        flexShrink: "0",
                        order: imageAlign === "left" ? 0 : 1,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AdvantageImage, {
                            src: backgroundImage,
                            priority: true,
                            height: 250,
                            width: 450,
                            objectFit: "cover",
                            alt: alt
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_4__.Box, {
                        flexGrow: 1,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_4__.Box, {
                            flexDirection: "column",
                            display: "flex",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AdvantageTitle, {
                                    children: title
                                }),
                                caption && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AdvantageDescription, {
                                    children: (0,_contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_3__/* .documentToReactComponents */ .h)(caption)
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}
function AdvantageImage(props) {
    var isSm = (0,qualification_hooks_useBreakpoints__WEBPACK_IMPORTED_MODULE_6__/* .useBreakpointDown */ .a)("sm");
    var baseWidth = 350;
    var baseHeight = 350;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
        src: props.src,
        width: isSm ? baseWidth * 0.8 : baseWidth,
        height: isSm ? baseHeight * 0.8 : baseHeight,
        objectFit: "contain",
        alt: ""
    });
}
var Advantage = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(_heycater_design_system__WEBPACK_IMPORTED_MODULE_4__.Box)(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(3);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(9);
});
function AdvantageTitle(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_4__.Typography, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        component: "h3",
        fontSize: {
            xs: 18,
            sm: 20,
            md: 36
        },
        mb: 1,
        fontWeight: 600
    }, props));
}
function AdvantageDescription(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_4__.Typography, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        fontSize: {
            xs: 14,
            sm: 16
        }
    }, props));
}


/***/ })

}]);